// extracted by mini-css-extract-plugin
module.exports = {"guide":"UploadCert_guide__3e6DG","intro":"UploadCert_intro__2ubNw","intro_1":"UploadCert_intro_1__1y0A9"};